import React, {useState} from "react";
import {createFactor, updateStatus} from "./crud/factorCrud";

export default function FactorForm({
                                    data
                                   }){

    const [factor_date, setFactor_date] = useState([]);
    let [status, setStatus] = useState([]);
    const [description, setDescription] = useState([]);




     function saveFactor(){
         if(status == ""){
             status="pending";
         }
        const formData = new FormData();
        formData.append('factor_date', factor_date);
        formData.append('status', status);
        formData.append('description',description);
         createFactor(formData)
            .then(() => {

            })
    }


    return (
        <>
           <div>
               <div class="input-group mb-5">
                   <span class="input-group-text" id="basic-addon1">تاریخ</span>
                   <input type="date" name="factor_date" onChange={e => setFactor_date(e.target.value)} class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1"/>
               </div>

               <div className="input-group mb-5">
                   <span className="input-group-text" id="basic-addon1">وضعیت</span>
                   <select name="status" onChange={e=>setStatus(e.target.value)} defaultValue="pending" className="form-control form-select" aria-label="انتخاب وضعیت">
                       <option value="pending">Pending</option>
                       <option value="done">Done</option>
                       <option value="cancel">Cancel</option>
                       <option value="close">Close</option>
                   </select>
               </div>


               <div class="input-group">
                   <span class="input-group-text">توضیح</span>
                   <textarea name="description" onChange={e=>setDescription(e.target.value)} class="form-control" aria-label="With textarea"></textarea>
               </div>

               <div className="input-group">
               <button className="btn btn-success" onClick={saveFactor}>ایجاد فاکتور</button>
               </div>

           </div>

        </>
    )
}